import { c as _c } from "react/compiler-runtime";
export default function UserPageSetUpProfileHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="lg:tw-flex lg:tw-items-center lg:tw-justify-between"><div className="tw-min-w-0 tw-flex-1"><div className="tw-flex tw-flex-col"><h2 className="tw-mb-1 tw-text-base tw-font-semibold tw-text-iron-50 sm:tw-text-lg">Set up your profile in 30 seconds or less</h2></div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}